import {
  DISTRIBUTION_TYPE_ADMIN_EVERYONE,
  DISTRIBUTION_TYPE_ADMIN_ROLE,
} from './SmartInsightConstants';

export const GET_ADMIN_REPOSITORIES_ENDPOINT = '/getadminrepositories';

export const MAX_REPOSITORY_NAME_LENGTH = 100;

export const REPOSITORY_NAME_VALIDATION_ERROR_MESSAGES = {
  MAX_LENGTH: `Repository Name cannot be greater than ${MAX_REPOSITORY_NAME_LENGTH} characters`,
  REQUIRED: 'Repository Name is required',
  SPECIAL_CHARACTERS: 'Repository Name cannot contain special characters',
  UNIQUE: 'Repository Name is not unique',
};

export const REPOSITORY_TYPES = [
  { label: 'Document', value: 'Document' },
  { label: 'MDF', value: 'MDF' },
  { label: 'PMF', value: 'PMF' },
];

export const NEW_REPOSITORY_SAVED_SEARCH_ID = 'new_root';

export const NEW_REPOSITORY_TEMPLATE = {
  version: '1',
  status: 'Inworks',
  type: 'Document',
  isTemplate: false,
  name: '',
  originalName: '',
  viewDistribution: {
    distributionFor: DISTRIBUTION_TYPE_ADMIN_ROLE,
    distributionList: [],
  },
  adminDistribution: {
    distributionFor: DISTRIBUTION_TYPE_ADMIN_EVERYONE,
    distributionList: [],
  },
  repositoryTree: [
    {
      nodeId: NEW_REPOSITORY_SAVED_SEARCH_ID,
      nodeText: 'All Documents',
      children: [],
      expanded: true,
    },
  ],
};
